import { styled, LinearProgress, linearProgressClasses } from '@mui/material';

export const DashboardVariantV2CarrierZoneSaturationTableOccupancyInfoProgressBar =
  styled(LinearProgress, {
    shouldForwardProp: (prop) => prop !== 'customColor',
  })<{ customColor: string }>(({ theme, customColor }) => ({
    flex: 1,
    height: 12,
    borderRadius: 999,
    backgroundColor: theme.palette.divider,

    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 999,
      backgroundColor: customColor,
    },
  }));
